export default function Styles(){
    return(

        <style>
            {`
            .BUS-head-title{
                color: #1B1B1B;
                font-family: 'Fjalla One';
            }
            `}
    
        </style>
    )
}